// Switches format from `000/00R00` to `0.00-00`
const obsolete = {
  bind(el, binding) {
    const inputs = el.querySelectorAll('input[type="text"]');
    const delimiters = el.querySelectorAll('.dimension-abbr')
    const firstInput = inputs[0]

    firstInput.addEventListener('input', () => {
      if (firstInput.value.includes('.')) {
        firstInput.value = firstInput.value.substr(0,firstInput.value.indexOf("."))
        inputs[1].select()
        delimiters[0].innerText = "."
        delimiters[1].innerText = "-"
        setTimeout(() => {
          inputs[1].dispatchEvent(new Event("input"));
        },1)
      } else if (firstInput.value === "") {
        delimiters[0].innerText = "/"
        delimiters[1].innerText = "R"
      }
    })
  },
};

export default obsolete;
